import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const TableBaseStyle = makeStyles(
  createStyles({
    //テーブルヘッダセル
    headerCell: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
    dialogBodyCellLeft: {
      borderWidth: '1px',
      borderColor: 'black',
      borderStyle: 'solid',
      backgroundColor: 'white',
      padding: '1px',
      paddingLeft: '10px',
      textAlign: 'left',
      height: '40px',
    },
    dialogBodyCellCenter: {
      borderWidth: '1px',
      borderColor: 'black',
      borderStyle: 'solid',
      backgroundColor: 'white',
      padding: '1px',
      paddingLeft: '10px',
      textAlign: 'center',
      height: '40px',
    },
    textFieldDialog: {
      flexGrow: 1,
      height: '100%',
      width: '95%',
      border: 'none',
      backgroundColor: 'transparent',
      textAlign: "center",
    },
    tableContainer: {
      maxHeight: 'calc(100vh - 300px)',
    },
    buttonStyle: {
      maxWidth: '200px',
      maxHeight: '35px',
      minWidth: '200px',
      minHeight: '35px',
    },
  })
);